const formazione = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_FORMAZIONE_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_FORMAZIONE_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getFormazioneComponent: state => state.component,
        getFormazioneEdit: state => state.edit
    }
}

export default formazione